import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';

import './CollegeExchangeDisclaimerNote.scss';
import { getProductTypes } from '../../../redux/modules/productTypes/productType.selectors';
import { collegeDisclaimerMap } from '../../../settings/settings';
import { arrayToSentence } from '../../../utils/utils';

export const CollegeExchangeDisclaimerNote = ({
  ProductTypes: { hasAK529, hasMD529, hasNAT529 },
}) => (
  <div className="e2e-exchange-disclaimer-note college-exchange-disclaimer-note">
    Exchanges can be performed between identically registered accounts. You are
    permitted to change investment options (portfolios) for a particular
    beneficiary twice per calendar year. If you have multiple portfolio accounts
    for a beneficiary, all investment changes requested on the same trade date
    will be considered as one change for the calendar year. For information on
    the minimum and maximum transaction amounts, please see the{' '}
    {arrayToSentence(
      [
        hasNAT529 && collegeDisclaimerMap.national,
        hasMD529 && collegeDisclaimerMap.maryland,
        hasAK529 && collegeDisclaimerMap.alaska,
      ]
        .filter((v) => v)
        .map(({ name, type, url }) => (
          <a
            className={`e2e-${type}-disclosure-link college-branded-link`}
            href={url}
            key={type}
            rel="noopener noreferrer"
            target="_blank"
          >
            {name}
          </a>
        ))
    )}
    .
  </div>
);

const mapStateToProps = (state) => ({
  ProductTypes: getProductTypes(state),
});

export default compose(connect(mapStateToProps))(CollegeExchangeDisclaimerNote);
